import React from 'react';

// Premium YEKÜV special-day donation cards.
// All data (image, title, body verb, accent color) is read from occasion object.
// Admin can edit these fields per-occasion in /admin/special-days.

export default function SpecialCard({ occasion, toName = '', fromName = '', note = '', amount = 0, id, showAmount = true }) {
  const image = occasion?.card_image || occasion?.image || 'https://images.pexels.com/photos/9139318/pexels-photo-9139318.jpeg?auto=compress&cs=tinysrgb&w=700';
  const title = occasion?.card_title || occasion?.title || 'Özel Gününüz İçin';
  const verb = occasion?.card_body || 'özel gününüz vesilesiyle';
  const accent = occasion?.accent_color || '#C9A96E';
  const finalTo = toName || 'Alıcı Adı';
  const finalFrom = fromName || 'Gönderen Adı';

  return (
    <div id={id} className="mx-auto" style={{ width: '100%', maxWidth: 380 }}>
      <div
        style={{
          aspectRatio: '2.5 / 5',
          background: '#FAF7F2',
          borderRadius: 18,
          position: 'relative',
          overflow: 'hidden',
          boxShadow: '0 24px 70px rgba(15, 30, 77, 0.28)',
          color: '#0F1E4D',
        }}
      >
        {/* Decorative image panel (top 45%) */}
        <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '45%', overflow: 'hidden' }}>
          {image && (
            <img
              src={image}
              alt=""
              crossOrigin="anonymous"
              style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
            />
          )}
          {/* Soft overlay for coherence */}
          <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to bottom, rgba(250,247,242,0) 60%, rgba(250,247,242,1))' }} />
        </div>

        {/* Subtle inner frame */}
        <div style={{ position: 'absolute', inset: 14, border: '1px solid rgba(15,30,77,0.25)', borderRadius: 10, pointerEvents: 'none' }} />

        {/* Content */}
        <div style={{ position: 'absolute', top: '45%', left: 0, right: 0, bottom: 0, padding: '18px 28px 24px', display: 'flex', flexDirection: 'column' }}>
          {/* Gold rule */}
          <div style={{ width: 38, height: 1.5, background: accent, margin: '0 auto 10px' }} />

          {/* Occasion label */}
          <div style={{ textAlign: 'center', fontSize: 9, letterSpacing: '0.32em', textTransform: 'uppercase', color: accent, fontWeight: 700 }}>
            {occasion?.tone || 'YEKÜV'}
          </div>

          {/* Title */}
          <div style={{ textAlign: 'center', marginTop: 8, padding: '0 4px' }}>
            <div style={{ fontFamily: 'Fraunces, Georgia, serif', fontSize: 20, lineHeight: 1.2, fontWeight: 500, letterSpacing: '-0.01em' }}>
              {title}
            </div>
          </div>

          {/* Body */}
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', paddingTop: 12 }}>
            <div style={{ textAlign: 'center', fontFamily: 'Fraunces, Georgia, serif', fontStyle: 'italic', color: '#2A3457', fontSize: 12.5, lineHeight: 1.6 }}>
              <span style={{ fontStyle: 'normal', fontWeight: 600 }}>Sayın, </span>
              <span style={{ fontStyle: 'normal', fontWeight: 600, color: '#0F1E4D' }}>{finalTo}</span>

              <div style={{ marginTop: 10 }}>
                <span style={{ fontStyle: 'normal', fontWeight: 600, color: '#0F1E4D' }}>{finalFrom}</span>
                <span>, {note ? note : `${verb},`}</span>
                {!note && (
                  <>
                    <div style={{ marginTop: 4 }}>sizin adınıza vakfımıza</div>
                    <div>bağışta bulunarak bir YEKÜV</div>
                    <div>Bursiyerinin eğitimine destek oldu.</div>
                  </>
                )}
              </div>
            </div>
          </div>

          {/* Amount */}
          {showAmount && amount > 0 && (
            <div style={{ textAlign: 'center', marginBottom: 8 }}>
              <div style={{ display: 'inline-block', padding: '4px 14px', border: `1px solid ${accent}`, color: '#0F1E4D', borderRadius: 999, fontFamily: 'Fraunces, serif', fontSize: 13, fontWeight: 600, letterSpacing: '0.02em' }}>
                ₺{amount.toLocaleString('tr-TR')}
              </div>
            </div>
          )}

          {/* Footer */}
          <div style={{ textAlign: 'center' }}>
            <div style={{ height: 1, background: 'rgba(15,30,77,0.12)', margin: '0 auto 8px', width: '55%' }} />
            <img src="/logos/yekuv-logo.png" alt="YEKÜV" crossOrigin="anonymous" style={{ height: 34, width: 'auto', margin: '0 auto', display: 'block' }} />
            <div style={{ fontFamily: 'Fraunces, serif', fontStyle: 'italic', fontSize: 9.5, marginTop: 4, letterSpacing: '0.03em', color: '#0F1E4D', opacity: 0.75 }}>
              "Bir Çocuk Daha Okusun Diye…"
            </div>
            <div style={{ fontSize: 8, color: '#0F1E4D', opacity: 0.45, marginTop: 3, letterSpacing: '0.12em' }}>
              yekuv.org · 444 28 39
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
